var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "axios";
import jsonp from "jsonp";
function groupByObjectValue(list, groupKey, groupListKey = "items", returnObj) {
  const createdGroups = new Map();
  let getGroupKey;
  if (typeof groupKey === "function") {
    getGroupKey = (a) => groupKey(a);
  } else if (typeof groupKey === "string") {
    getGroupKey = (a) => a[groupKey];
  } else {
    console.debug("Invalid groupKey provided. Should be a string or a function", groupKey);
    return false;
  }
  const getGroupObj = typeof returnObj === "function" ? (obj, name) => returnObj(obj, name) : (obj, name) => ({
    type: "group",
    name,
    [groupListKey]: [obj]
  });
  return list.reduce((acc, cur) => {
    const curGroupKey = getGroupKey(cur) || "other";
    if (createdGroups.has(curGroupKey)) {
      const existingGroupIndex = createdGroups.get(curGroupKey);
      if (typeof existingGroupIndex === "number") {
        acc[existingGroupIndex][groupListKey].push(cur);
      }
    } else {
      createdGroups.set(curGroupKey, acc.length);
      acc.push(getGroupObj(cur, curGroupKey));
    }
    return acc;
  }, []);
}
function shuffle(list) {
  if (Array.isArray(list) && list.length > 1) {
    return list.sort(() => 0.5 - Math.random());
  }
  return list;
}
function validateProps(props, data) {
  Object.entries(props).forEach(([key, value]) => {
    let dataType = typeof data[key];
    if (dataType === "object" && Array.isArray(data[key])) {
      dataType = "array";
    }
    if (value.required && dataType === "undefined") {
      throw new Error(`Missing required value: ${key}`);
    } else if (Array.isArray(value.types) && dataType !== "undefined") {
      if (!value.types.includes(dataType)) {
        throw new Error(`Incorrect value type for: ${key}. Expected: ${value.types.join(", ")}, got ${dataType}`);
      }
    }
  });
  return true;
}
function sortBy({ data, sortKey, direction = "AZ" }) {
  const props = {
    data: {
      required: true,
      types: ["array"]
    },
    sortKey: {
      required: true,
      types: ["string"]
    },
    direction: {
      required: true,
      types: ["string"]
    }
  };
  validateProps(props, { data, sortKey, direction });
  const inverter = direction === "ZA" ? 1 : -1;
  data.sort((a, b) => a[sortKey] < b[sortKey] ? 1 * inverter : -1 * inverter);
  return data;
}
function sortByArray({ data, sortKey, order }) {
  const props = {
    data: {
      required: true,
      types: ["array"]
    },
    sortKey: {
      required: true,
      types: ["string"]
    },
    order: {
      required: true,
      types: ["array"]
    }
  };
  validateProps(props, { data, sortKey, order });
  const indexes = order.reduce((acc, cur, index) => {
    acc[cur] = index;
    return acc;
  }, {});
  function getIndexPosition(val) {
    if (val && typeof indexes[val] === "number") {
      return indexes[val];
    }
    return 999;
  }
  return data.sort((a, b) => getIndexPosition(a[sortKey]) - getIndexPosition(b[sortKey]));
}
function containsTargetElement(element, event) {
  return element && event.target && element.contains(event.target);
}
function select(container, selector) {
  if (container && selector) {
    const el = container.querySelector(selector);
    if (el) {
      el.focus();
      el.select();
    }
  }
}
function focusFirstTabIndex(container) {
  dom_setFocus(container, "first");
}
function dom_setFocus(container, target = "first") {
  if (container) {
    const el = container.querySelectorAll("[tabindex]");
    const focusableElements = Array.from(el).filter((it) => it.getAttribute("tabindex") !== "-1");
    if (["first", "last"].includes(target)) {
      const element = focusableElements[target === "first" ? 0 : focusableElements.length - 1];
      if (element) {
        element.focus();
      }
    } else {
      const currentFocus = document.activeElement;
      const currentFocusIndex = currentFocus ? focusableElements.indexOf(currentFocus) : -1;
      if (currentFocusIndex > -1) {
        const element = focusableElements[target === "next" ? currentFocusIndex + 1 : currentFocusIndex - 1];
        if (element) {
          element.focus();
        }
      } else {
        dom_setFocus(container, "first");
      }
    }
  }
}
function supportsLocalStorage() {
  try {
    const test = "p5-services-check-localStorage";
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}
const dateTimeFormats = {
  d: {
    day: "numeric"
  },
  dd: {
    day: "2-digit"
  },
  "dd m": {
    day: "2-digit",
    month: "numeric"
  },
  "d mm": {
    day: "numeric",
    month: "2-digit"
  },
  "dd mm": {
    day: "2-digit",
    month: "2-digit"
  },
  "dd mm yyyy": {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  },
  "DD dd mm yyyy": {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  },
  "hh ii": {
    hour: "2-digit",
    minute: "2-digit"
  },
  "dd mm hh ii": {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  },
  "dd mm yyyy hh ii": {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  },
  "DD dd mm yyyy hh ii": {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }
};
function dates_getWeekNumber(date = new Date()) {
  date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((date.getTime() - yearStart.getTime()) / 864e5 + 1) / 7);
  return weekNo;
}
function dates_getDateFromIntlParts(parts) {
  const date = new Date();
  const groupedParts = parts.reduce((acc, cur) => {
    const accKeys = Object.keys(acc);
    if (accKeys.includes(cur.type)) {
      acc[cur.type] = +cur.value;
    }
    return acc;
  }, {
    day: void 0,
    month: void 0,
    year: void 0,
    hour: void 0,
    minute: void 0,
    seconds: 0
  });
  if (groupedParts.day) {
    date.setDate(groupedParts.day);
  }
  if (groupedParts.month) {
    date.setMonth(groupedParts.month - 1);
  }
  if (groupedParts.year) {
    date.setFullYear(groupedParts.year);
  }
  if (groupedParts.hour) {
    date.setHours(groupedParts.hour);
  }
  if (groupedParts.minute) {
    date.setMinutes(groupedParts.minute);
  }
  if (groupedParts.seconds) {
    date.setMinutes(groupedParts.seconds);
  }
  return date;
}
function dates_getDateInTimezone(timeZone = "Europe/Amsterdam") {
  try {
    const response = Intl.DateTimeFormat("ia", {
      timeZoneName: "short",
      timeZone,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }).formatToParts();
    return response;
  } catch (e) {
    return false;
  }
}
function dates_getFirstWeekDayAfter(date = new Date(), day) {
  const internalDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  internalDate.setDate(internalDate.getDate() + (day + 7 - internalDate.getDay()) % 7);
  return internalDate;
}
function dates_getTimestampFromDate(val = new Date(), as_midnight = false, as_utc = false) {
  if (as_midnight) {
    const dateCopy = new Date(val.getTime());
    if (as_utc) {
      dateCopy.setUTCHours(0, 0, 0);
    } else {
      dateCopy.setHours(0, 0, 0);
    }
    return Math.floor(dateCopy.getTime() / 1e3);
  }
  return Math.floor(val.getTime() / 1e3);
}
function dates_getRange(startdate, enddate) {
  const dates = [];
  const currentDate = startdate;
  while (currentDate <= enddate) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
}
function dates_sort(dates) {
  dates.sort((a, b) => a.getTime() - b.getTime());
}
async function processUrls(list, http, settings) {
  const promises = [];
  const returnUrls = [];
  list.forEach((page) => {
    if (typeof page === "string") {
      returnUrls.push(generateXml(page, settings));
    } else if (page.endpoint) {
      promises.push(getRemoteData(page, http, settings));
    }
  });
  await Promise.all(promises).then((remoteSets) => {
    remoteSets.forEach((remoteSet) => {
      returnUrls.push(...remoteSet);
    });
  }).catch(console.error);
  return returnUrls;
}
function getRemoteData(page, http, settings) {
  return new Promise((resolve, reject) => {
    if (page.data) {
      resolve(remoteDataToPages(page.data.results, page, settings));
    } else {
      http.get(page.endpoint).then((r) => {
        if (r.status === 200 && r.data.status === "success") {
          resolve(remoteDataToPages(r.data.results, page, settings));
        } else {
          reject();
        }
      }).catch(reject);
    }
  });
}
function remoteDataToPages(data, { path, langPath }, settings) {
  return data.reduce((acc, cur) => {
    if (path) {
      acc.push(generateXml(path(cur), settings));
    } else if (langPath) {
      const languagePaths = settings.languages.map((it) => langPath(cur, it));
      acc.push(generateXml(languagePaths, settings));
    }
    return acc;
  }, []);
}
function getUrl(url, index) {
  if (typeof url === "string") {
    return url;
  }
  return url[index];
}
let langReplaceRegex;
function generateAlternateLangs(url, languages, languageMode, baseUrl) {
  if (languageMode === "url") {
    return languages.map((lang, index) => `<xhtml:link rel="alternate" hreflang="${lang}" href="${baseUrl}${getUrl(url, index).replace(langReplaceRegex, `/${lang}/`)}" />`).join("\n");
  }
  return ["x-default", ...languages].map((lang, index) => {
    const baseLink = getUrl(url, index === 0 ? index : index - 1);
    const href = `${baseLink}${lang !== "x-default" ? `${baseLink.includes("?") ? "&" : "?"}lang=${lang}` : ""}`;
    return `<xhtml:link rel="alternate" hreflang="${lang}" href="${baseUrl}${href}" />`;
  }).join("\n");
}
function generateMainLangUrl(url) {
  return url.replace(langReplaceRegex, "/");
}
function generateXml(page, { languages, languageMode = "url", baseUrl }) {
  const url = `${baseUrl}${getUrl(page, 0)}`;
  return `
        <url>
            <loc>${languageMode === "url" && languages.length > 1 ? generateMainLangUrl(url) : url}</loc>${languages.length > 1 ? `
${generateAlternateLangs(page, languages, languageMode, baseUrl)}` : ""}
            <changefreq>daily</changefreq>
            <priority>0.8000</priority>
        </url>
    `;
}
async function generateSitemap(pages, settings) {
  const http = axios.create({
    baseURL: `${settings.apiUrl}`,
    headers: {
      Authorization: `Bearer ${settings.apiToken}`,
      namespace: `${settings.apiNamespace}`
    }
  });
  langReplaceRegex = new RegExp(`/${settings.language}(?:$|/)`);
  const urls = await processUrls(pages, http, settings);
  const xml_content = [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<urlset xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd http://www.w3.org/1999/xhtml http://www.w3.org/2002/08/xhtml/xhtml1-strict.xsd" xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml" >',
    ...urls,
    "</urlset>"
  ];
  return {
    statusCode: 200,
    headers: { "Content-Type": "text/xml" },
    body: xml_content.join("\n")
  };
}
const activeRequests = new Map();
function addRequest(config) {
  const name = config.name;
  if (name) {
    if (activeRequests.has(name)) {
      activeRequests.get(name).cancel("canceled by next request");
    }
    const source = axios.CancelToken.source();
    activeRequests.set(name, source);
    config.cancelToken = source.token;
  }
  return config;
}
function clearRequest(config) {
  const name = config.name;
  if (name) {
    activeRequests.delete(name);
  }
}
function http_cancelDuplicates(instance) {
  instance.interceptors.request.use(addRequest);
  instance.interceptors.response.use((response) => {
    clearRequest(response.config);
    return response;
  }, (error) => {
    if (error == null ? void 0 : error.config) {
      clearRequest(error.config);
    }
    return Promise.reject(error);
  });
}
function http_responseFormat(instance) {
  instance.interceptors.response.use((response) => {
    response.data.statusCode = response.status;
    return response.data;
  }, (error) => Promise.reject(error));
}
class Mailchimp {
  constructor({ dataCenter, userID, listID }) {
    __publicField(this, "dataCenter");
    __publicField(this, "userID");
    __publicField(this, "listID");
    const props = {
      dataCenter: {
        required: true,
        types: ["string"]
      },
      userID: {
        required: true,
        types: ["string"]
      },
      listID: {
        required: true,
        types: ["string"]
      }
    };
    validateProps(props, { dataCenter, userID, listID });
    this.dataCenter = dataCenter;
    this.userID = userID;
    this.listID = listID;
  }
  subscribeUrl(params = {}) {
    const queryParams = __spreadValues({
      u: this.userID,
      id: this.listID
    }, params);
    let query = new URLSearchParams(queryParams).toString();
    if (query) {
      query = `?${query}`;
    }
    return `https://name.${this.dataCenter}.list-manage.com/subscribe/post-json${query}`;
  }
  subscribe(_a) {
    var fields = __objRest(_a, []);
    return new Promise((resolve, reject) => {
      const url = this.subscribeUrl(fields);
      jsonp(url, { param: "c" }, (err, res) => {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      });
    });
  }
}
const proxy = "https://europe-west1-blixem.cloudfunctions.net/corsprox";
class ActiveCampaign {
  constructor({ apiURL, apiToken, endpoint = "contacts" }) {
    __publicField(this, "url");
    __publicField(this, "token");
    __publicField(this, "endpoint");
    __publicField(this, "getData", (fields) => {
      const defaultFields = ["email", "firstName", "lastName", "phone"];
      return Object.entries(fields).reduce((acc, [key, value]) => {
        if (defaultFields.includes(key)) {
          acc[key] = value;
        } else {
          acc.fieldValues.push({
            field: typeof key === "number" ? key.toString() : key,
            value
          });
        }
        return acc;
      }, {
        fieldValues: []
      });
    });
    __publicField(this, "validateData", (fields) => !!fields.email);
    const props = {
      apiURL: {
        required: true,
        types: ["string"]
      },
      apiToken: {
        required: true,
        types: ["string"]
      },
      endpoint: {
        required: true,
        types: ["string"]
      }
    };
    validateProps(props, { apiURL, apiToken, endpoint });
    this.url = apiURL;
    this.token = apiToken;
    this.endpoint = endpoint;
  }
  subscribe(fields) {
    return new Promise((resolve, reject) => {
      if (!this.validateData(fields)) {
        reject(new Error("email is required"));
      }
      const data = { contact: this.getData(fields) };
      axios({
        method: "POST",
        headers: {
          "Api-Token": this.token,
          "target-url": `${this.url}/${this.endpoint}/`
        },
        url: proxy,
        data
      }).then((r) => {
        if (r.status === 201) {
          resolve(r.data);
        } else {
          reject(new Error(`Invalid responsecode: ${r.status}`));
        }
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          resolve(data);
        } else {
          reject(error);
        }
      });
    });
  }
  syncContact(data) {
    return new Promise((resolve, reject) => {
      if (!data.email) {
        reject(new Error("email is required"));
      } else {
        axios({
          method: "POST",
          headers: {
            "Api-Token": this.token,
            "target-url": `${this.url}/contact/sync/`
          },
          url: proxy,
          data: {
            contact: this.getData(data)
          }
        }).then((r) => {
          if ([200, 201].includes(r.status)) {
            resolve(r.data.contact.id);
          } else {
            console.error(r);
            reject(new Error(`Invalid responsecode: ${r.status}`));
          }
        }).catch((error) => {
          console.error(error);
          reject(error);
        });
      }
    });
  }
  addContactTag(contactID, tagID) {
    return new Promise((resolve, reject) => {
      if (!contactID || !tagID) {
        reject(new Error("Invalid parameters. contactID and tagID are required"));
      } else if (typeof contactID !== "string" && typeof tagID !== "string") {
        reject(new Error("contactID and tagID should be strings"));
      } else {
        axios({
          method: "POST",
          headers: {
            "Api-Token": this.token,
            "target-url": `${this.url}/contactTags/`
          },
          url: proxy,
          data: {
            contactTag: {
              contact: contactID,
              tag: tagID
            }
          }
        }).then((r) => {
          if ([200, 201].includes(r.status)) {
            resolve(r.data.contactTag);
          } else {
            console.error(r.data);
            try {
              console.error(JSON.stringify(r.data));
            } catch (e) {
            }
            reject(new Error(`Invalid responsecode: ${r.status}`));
          }
        }).catch((error) => {
          console.error(error);
          reject(error);
        });
      }
    });
  }
}
function rad2degr(rad) {
  return rad * 180 / Math.PI;
}
function degr2rad(degr) {
  return degr * Math.PI / 180;
}
function maps_getCenter(coords) {
  if (!coords.length) {
    return { lat: 0, lng: 0 };
  }
  let sumX = 0;
  let sumY = 0;
  let sumZ = 0;
  coords.forEach((coord) => {
    const lat2 = degr2rad(coord.lat);
    const lng2 = degr2rad(coord.lng);
    sumX += Math.cos(lat2) * Math.cos(lng2);
    sumY += Math.cos(lat2) * Math.sin(lng2);
    sumZ += Math.sin(lat2);
  });
  const avgX = sumX / coords.length;
  const avgY = sumY / coords.length;
  const avgZ = sumZ / coords.length;
  const lng = Math.atan2(avgY, avgX);
  const hyp = Math.sqrt(avgX * avgX + avgY * avgY);
  const lat = Math.atan2(avgZ, hyp);
  return { lat: rad2degr(lat), lng: rad2degr(lng) };
}
const numberFormats = {
  USD: {
    style: "currency",
    currency: "USD",
    currencyDisplay: "narrowSymbol"
  },
  EUR: {
    style: "currency",
    currency: "EUR",
    currencyDisplay: "narrowSymbol"
  },
  "decimals-0": {
    style: "decimal",
    maximumFractionDigits: 0
  },
  "decimals-1": {
    style: "decimal",
    maximumFractionDigits: 1
  },
  "decimals-2": {
    style: "decimal",
    maximumFractionDigits: 2
  },
  "decimals-3": {
    style: "decimal",
    maximumFractionDigits: 3
  },
  "decimals-1-all": {
    style: "decimal",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  },
  "decimals-2-all": {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  },
  "decimals-3-all": {
    style: "decimal",
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  }
};
function numbers_getRange(start, end, step = 1, skip = []) {
  const response = [];
  for (let i = start; i <= end; i += step) {
    if (!skip.includes(i)) {
      response.push(i);
    }
  }
  return response;
}
function numbers_roundToInt(val, int = 1) {
  const y = val + int / 2;
  return y - y % int;
}
function numbers_roundToClosestFromArray(val, numbers) {
  return numbers.reduce((acc, cur) => Math.abs(cur - val) < Math.abs(acc - val) ? cur : acc, numbers[0]);
}
function contrastText(val, splitPart = "==", startString = "<strong>", endString = "</strong>") {
  if (typeof val === "string") {
    const parts = val.split(splitPart);
    return parts.map((part, index) => {
      if (index % 2 === 0) {
        return part;
      }
      return `${startString}${part}${endString}`;
    }).join("");
  }
  return val;
}
const rateHistory = {};
const conversionValues = {
  area: {
    options: [{ label: "m2" }, { label: "ft2" }],
    conversions: {
      m2: {
        ft2: { operator: "multiply", value: 10.764 }
      },
      ft2: {
        m2: { operator: "divide", value: 10.764 }
      }
    }
  },
  currency: {
    options: [{ label: "USD" }, { label: "EUR" }, { label: "GBP" }],
    async conversions(value, from, to) {
      let history = rateHistory[from];
      if (typeof history === "undefined") {
        const response = await axios.get(`https://api.frankfurter.app/latest?from=${from}`);
        if (response.data.rates) {
          rateHistory[from] = response.data.rates;
          history = response.data.rates;
        }
      }
      return value * rateHistory[from][to];
    }
  },
  distance: {
    options: [
      { label: "ft" },
      { label: "in" },
      { label: "yd" },
      { label: "mi" },
      { label: "mm" },
      { label: "cm" },
      { label: "m" },
      { label: "km" }
    ],
    conversions: {
      ft: {
        in: { operator: "multiply", value: 12 },
        yd: { operator: "multiply", value: 0.33333 },
        mi: { operator: "multiply", value: 18939e-8 },
        mm: { operator: "divide", value: 32808e-7 },
        cm: { operator: "divide", value: 0.032808 },
        m: { operator: "divide", value: 3.2808 },
        km: { operator: "divide", value: 3280.8 }
      },
      in: {
        ft: { operator: "multiply", value: 0.083333 },
        yd: { operator: "multiply", value: 0.027778 },
        mi: { operator: "multiply", value: 15783e-9 },
        mm: { operator: "divide", value: 0.03937 },
        cm: { operator: "divide", value: 0.3937 },
        m: { operator: "divide", value: 39.37 },
        km: { operator: "divide", value: 39370 }
      },
      yd: {
        ft: { operator: "multiply", value: 3 },
        in: { operator: "multiply", value: 36 },
        mi: { operator: "multiply", value: 56818e-8 },
        mm: { operator: "divide", value: 10936e-7 },
        cm: { operator: "divide", value: 0.010936 },
        m: { operator: "divide", value: 1.0936 },
        km: { operator: "divide", value: 1093.6 }
      },
      mi: {
        ft: { operator: "multiply", value: 5280 },
        in: { operator: "multiply", value: 63360 },
        yd: { operator: "multiply", value: 1760 },
        mm: { operator: "divide", value: 62137e-11 },
        cm: { operator: "divide", value: 62137e-10 },
        m: { operator: "divide", value: 62137e-8 },
        km: { operator: "divide", value: 0.62137 }
      },
      mm: {
        ft: { operator: "multiply", value: 32808e-7 },
        in: { operator: "multiply", value: 0.03937 },
        yd: { operator: "multiply", value: 10936e-7 },
        mi: { operator: "divide", value: 62137e-11 },
        cm: { operator: "divide", value: 10 },
        m: { operator: "divide", value: 1e3 },
        km: { operator: "divide", value: 1e6 }
      },
      cm: {
        ft: { operator: "multiply", value: 0.032808 },
        in: { operator: "multiply", value: 0.3937 },
        yd: { operator: "multiply", value: 0.010936 },
        mi: { operator: "divide", value: 62137e-10 },
        mm: { operator: "divide", value: 0.1 },
        m: { operator: "divide", value: 100 },
        km: { operator: "divide", value: 1e5 }
      },
      m: {
        ft: { operator: "multiply", value: 3.2808 },
        in: { operator: "multiply", value: 39.37 },
        yd: { operator: "multiply", value: 1.0936 },
        mi: { operator: "multiply", value: 62137e-8 },
        mm: { operator: "multiply", value: 1e3 },
        cm: { operator: "multiply", value: 100 },
        km: { operator: "divide", value: 1e3 }
      },
      km: {
        ft: { operator: "multiply", value: 3280.8 },
        in: { operator: "multiply", value: 39370 },
        yd: { operator: "multiply", value: 1093.6 },
        mi: { operator: "multiply", value: 0.62137 },
        mm: { operator: "multiply", value: 1e6 },
        cm: { operator: "multiply", value: 1e5 },
        m: { operator: "multiply", value: 1e3 }
      }
    }
  }
};
async function convert(value, from, to, type) {
  if (typeof value === "number") {
    const typeConversions = conversionValues[type].conversions;
    if (typeof typeConversions === "function") {
      return typeConversions(value, from, to);
    }
    const conversion = typeConversions[from] && typeConversions[from][to] ? typeConversions[from][to] : void 0;
    if (conversion) {
      switch (conversion.operator) {
        case "divide":
          return value / conversion.value;
        case "multiply":
          return value * conversion.value;
        case "add":
          return value + conversion.value;
        case "subtract":
          return value - conversion.value;
      }
    }
  }
  return value;
}
function getFirstLetterOfEveryWord(text, max = 2) {
  if (typeof text === "string" && text) {
    return text.split(" ").reduce((acc, cur) => acc.length < max ? `${acc}${cur[0]}` : acc, "");
  }
  return "";
}
function generatePassword() {
  return `${Math.random().toString(36).slice(-8)}${Math.random().toString(36).slice(-8)}`;
}
function getLocaleText(obj, key, locale, fallback = "") {
  if (obj && key && locale) {
    const localeKey = `${key}_${locale}`;
    if (typeof obj[localeKey] !== "undefined") {
      return obj[localeKey];
    }
    return fallback;
  }
  return fallback;
}
function nl2br(val = "") {
  if (typeof val === "string") {
    return val.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br />$2");
  }
  return val;
}
function replaceBrackets(val, data) {
  const props = {
    val: {
      required: true,
      types: ["string"]
    },
    data: {
      required: true,
      types: ["object"]
    }
  };
  validateProps(props, { val, data });
  Object.keys(data).forEach((key) => {
    if (val.includes(`[${key}]`)) {
      val = val.replace(`[${key}]`, data[key]);
    }
  });
  return val;
}
function scorePassword(pass) {
  let score = 0;
  if (!pass || typeof pass !== "string")
    return score;
  const letters = {};
  for (let i = 0; i < pass.length; i += 1) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5 / letters[pass[i]];
  }
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  };
  let variationCount = 0;
  Object.values(variations).forEach((check) => {
    variationCount += check === true ? 1 : 0;
  });
  score += (variationCount - 1) * 10;
  return score;
}
function linkify(val, external = true) {
  if (typeof val === "string" && val) {
    const regex = /(?:(?:https?:\/\/)?(?:www\.|(?!www)))([a-zA-Z0-9@]+[a-zA-Z0-9-]\.[^\s<>]{2,})/g;
    const result = val.replace(regex, (match) => {
      let urlPrefix = match.includes("@") ? "mailto:" : "https://";
      if (match.startsWith("https://") || match.startsWith("mailto:")) {
        urlPrefix = "";
      }
      return `<a href="${urlPrefix}${match}" ${external ? 'target="_blank"' : ""} rel="nofollow noreferrer">${match}</a>`;
    });
    return result;
  }
  return val;
}
function embedUrl(url) {
  if (!url || typeof url !== "string") {
    return false;
  }
  return isYoutube(url) || isVimeo(url) || false;
}
function isYoutube(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  if (match && match[7]) {
    return {
      type: "youtube",
      id: match[7],
      src: `https://www.youtube.com/embed/${match[7]}`
    };
  }
  return false;
}
function isVimeo(url) {
  const regExp = /(?:http|https)?:?\/?\/?(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
  const match = url.match(regExp);
  if (match && match[1]) {
    return {
      type: "vimeo",
      id: match[1],
      src: `https://player.vimeo.com/video/${match[1]}`
    };
  }
  return false;
}
function cdnUrl(path, cdnPath) {
  if (!path) {
    return "";
  }
  if (path.indexOf("http") === 0) {
    return path;
  }
  return `${cdnPath || "cdnpath-not-defined/"}${path}`;
}
function imageSizes(path, widths) {
  if (!path) {
    return "";
  }
  const extension = path.split(".").pop();
  return widths.reduce((acc, size, index) => {
    if (acc) {
      acc += ", ";
    }
    if (index === widths.length - 1) {
      acc += `${path} ${size}w`;
    } else {
      acc += `${path}-${size}w.${extension} ${size}w`;
    }
    return acc;
  }, "");
}
const storeKey = "storedLang";
function getLanguages(langString) {
  return langString.split(",");
}
function isValidLang(langs, lang) {
  return lang && langs.includes(lang) ? lang : void 0;
}
function storeLanguage(lang) {
  if (supportsLocalStorage()) {
    localStorage.setItem(storeKey, lang);
  }
}
function getDefaultLang(langString) {
  const allowedLanguages = getLanguages(langString);
  let storedLanguage;
  if (supportsLocalStorage() && localStorage.getItem(storeKey)) {
    storedLanguage = isValidLang(allowedLanguages, localStorage.getItem(storeKey));
  }
  const browserLanguage = navigator && navigator.language ? isValidLang(allowedLanguages, navigator.language) : void 0;
  return storedLanguage || browserLanguage || allowedLanguages[0];
}
export { ActiveCampaign, Mailchimp, cdnUrl, containsTargetElement, contrastText, conversionValues, convert, dateTimeFormats, dates_getDateFromIntlParts, dates_getDateInTimezone, dates_getFirstWeekDayAfter, dates_getRange, dates_getTimestampFromDate, dates_getWeekNumber, dates_sort, dom_setFocus, embedUrl, focusFirstTabIndex, generatePassword, generateSitemap, getDefaultLang, getFirstLetterOfEveryWord, getLanguages, getLocaleText, groupByObjectValue, http_cancelDuplicates, http_responseFormat, imageSizes, linkify, maps_getCenter, nl2br, numberFormats, numbers_getRange, numbers_roundToClosestFromArray, numbers_roundToInt, replaceBrackets, scorePassword, select, shuffle, sortBy, sortByArray, storeLanguage, supportsLocalStorage, validateProps };
//# sourceMappingURL=services.es.js.map
